import { UnpublishedOutlined } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import Signatario from '../certidao/Signatario';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class PublicarEditalCancelamentoPautaLote extends ReactComponent {
    dialogListagemOpen = false;

    dialogConfirmacaoOpen = false;

    carregando = false;

    carregandoPreVisualizacao = false;

    dataLimitePublicacao;

    dataLimiteDisponibilizacao;

    dataLimiteEnvio;

    dataDisponibilizacao;

    dataProximaDisponibilizacao;

    dataPublicacao;

    cpfSignatario;

    errosValidacaoFechamento = [];

    previaPublicacaoHTML = '';

    openDialog = false;

    cabecalhoPublicacao;

    handleClickIcone = () => {
        this.dialogListagemOpen = true;
        this.carregarSignatario();
        this.limparProcessoPesquisa();
    };

    handleCloseDialog = () => {
        this.dialogListagemOpen = false;
    };

    handleCloseDialogConfirmacao = () => {
        this.dialogConfirmacaoOpen = false;
    };

    handleConfirmarPublicarEdital = async () => {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Publicar edital de cancelamento de processos',
            indeterminate: true,
            qtdTotalProcessos: this.processosConfirmacao.length,
            lotesProcessos: [this.processosConfirmacao],
            funcaoOperacao: this.confirmarPublicarPauta
        });
        this.handleCloseDialogConfirmacao();
        await this.sessaoStore.recarregarListaProcessos();
    };

    confirmarPublicarPauta = async () => {
        const resultado = await this.sessaoService.confirmarPublicarPauta(
            this.pautaJulgamentoStore.idPautaSelecionada,
            this.publicarPautaDto,
            false,
            true,
            false
        );
        this.pautaJulgamentoStore.atualizarProcessamentoLote(resultado);
        return resultado;
    };

    carregar = async () => {
        runInAction(() => (this.carregando = true));

        if (this.sessao) {
            const prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento()
            );
            runInAction(() => {
                this.dataLimitePublicacao = moment(prazos.dataLimitePublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataLimiteDisponibilizacao = moment(
                    prazos.dataLimiteDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataLimiteEnvio = moment(prazos.dataLimiteEnvio, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataProximaDisponibilizacao = moment(
                    prazos.dataProximaDisponibilizacao,
                    'DD-MM-YYYY-HH-mm-ss',
                    true
                );
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
            const cabecalhoPublicacao = await this.sessaoService.buscarCabecalhoEditalCancelamento(
                this.pautaJulgamentoStore.idPautaSelecionada
            );
            runInAction(() => (this.cabecalhoPublicacao = cabecalhoPublicacao));
        }
        runInAction(() => (this.carregando = false));
    };

    handleChangeDataDisponibilizacao = async (value) => {
        this.dataDisponibilizacao = this.formatarValorData(value);

        if (this.dataDisponibilizacao) {
            const prazos = await this.sessaoService.recuperarPrazosPublicacaoPauta(
                this.pautaJulgamentoStore.getDataInicioJulgamento(),
                this.dataDisponibilizacao.format('DD-MM-YYYY-HH-mm-ss')
            );
            runInAction(() => {
                this.dataPublicacao = moment(prazos.dataProximaPublicacao, 'DD-MM-YYYY-HH-mm-ss', true);
                this.dataDisponibilizacao = moment(prazos.dataProximaDisponibilizacao, 'DD-MM-YYYY-HH-mm-ss', true);
            });
        }
    };

    handleChangeDataPublicacao = (value) => {
        this.dataPublicacao = this.formatarValorData(value);
    };

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    handleClickConfirmar = async () => {
        this.dialogConfirmacaoOpen = true;
        await this.carregar();
    };

    handleCabecalhoPublicacao = (event) => {
        this.cabecalhoPublicacao = event.target.value;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            confirmarPublicarPauta: true,
            mensagemSucesso: true,
            carregar: true,
            carregarSignatario: true,
            sessao: true,
            quantidadeProcessosPorTipoInclusao: true,
            formatarValorData: true,
            processosSelecionaveis: true,
            render: true,
            renderDialogConfirmacao: true,
            getTooltipBotaoConfirmar: true,
            isStringPreenchida: true,
            renderConteudoConfirmacao: true,
            getMinDate: true,
            renderDataDisponibilizacaoDataPublicacao: true,
            renderCabecalhoPublicacao: true,
            renderCamposPublicacao: true,
            renderAlertaGeral: true,
            dialogListagemOpen: observable,
            dialogConfirmacaoOpen: observable,
            carregando: observable,
            carregandoPreVisualizacao: observable,
            dataLimitePublicacao: observable,
            dataLimiteDisponibilizacao: observable,
            dataLimiteEnvio: observable,
            dataDisponibilizacao: observable,
            dataProximaDisponibilizacao: observable,
            dataPublicacao: observable,
            cpfSignatario: observable,
            errosValidacaoFechamento: observable,
            previaPublicacaoHTML: observable,
            openDialog: observable,
            cabecalhoPublicacao: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleCloseDialogConfirmacao: action,
            handleConfirmarPublicarEdital: action,
            publicarPautaDto: computed,
            processosConfirmacao: computed,
            processosPublicacaoEdital: computed,
            callbackAlterarCpfSignatario: action,
            quantidadeProcessosSelecionados: computed,
            desabilitarPublicar: computed,
            handleChangeDataDisponibilizacao: action,
            handleChangeDataPublicacao: action,
            limparProcessoPesquisa: action,
            processos: computed,
            processosSelecionados: computed,
            existeProcessoParaPublicacaoEdital: computed,
            quantidadeProcessosPublicacaoEdital: computed,
            mensagemLoteSemProcessos: computed,
            handleClickConfirmar: action,
            handleCabecalhoPublicacao: action,
            renderConteudo: computed,
            desabilitarConfirmar: computed,
            mensagemConfirmacaoPublicacaoDiario: computed,
            mensagemValidacaoDataDisponibilizacao: computed
        });
    }

    get publicarPautaDto() {
        const publicarPautaDto = {
            dataDisponibilizacao: this.dataDisponibilizacao.format('YYYY-MM-DD'),
            dataPublicacao: this.dataPublicacao.format('YYYY-MM-DD'),
            cpfSignatario: this.cpfSignatario,
            processosConfirmacao: this.processosConfirmacao,
            cabecalhoPublicacao: this.cabecalhoPublicacao,
            tipoPublicacao: 'EDITAL_CANCELAMENTO'
        };

        return publicarPautaDto;
    }

    get mensagemSucesso() {
        return this.processosSelecionados.length > 1
            ? 'Editais de cancelamentos publicados com sucesso'
            : 'Edital de cancelameto publicado com sucesso';
    }

    get processosConfirmacao() {
        return this.processosSelecionados.map((registro) => ({
            numero: registro.processo.numeroCompleto,
            publicar: this.store.isCheckedOperacoesEmLote(registro),
            confirmar: false
        }));
    }

    get processosPublicacaoEdital() {
        return this.processosSelecionados.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    carregarSignatario() {
        if (this.sessao.orgaoJudicante) {
            this.cpfSignatario = this.dominioStore.temSignatariosCadastradosOjc(this.sessao.orgaoJudicante.sigla)
                ? this.dominioStore.signatarioCadastradoDefaultOjc(this.sessao.orgaoJudicante.sigla).cpf
                : this.usuarioStore.usuario.cpf;
        } else {
            this.cpfSignatario = this.usuarioStore.usuario.cpf;
        }
    }

    callbackAlterarCpfSignatario(cpfSignatario) {
        this.cpfSignatario = cpfSignatario;
    }

    get sessao() {
        return this.pautaJulgamentoStore.sessaoSelecionada;
    }

    get quantidadeProcessosSelecionados() {
        return this.processosSelecionados.length;
    }

    quantidadeProcessosPorTipoInclusao(tipoInclusao) {
        return this.processosSelecionados.filter((processo) => processo.tipoInclusao === tipoInclusao).length;
    }

    get desabilitarPublicar() {
        return !this.existeProcessoParaPublicacaoEdital;
    }

    formatarValorData(value) {
        const novoValor = value
            ? moment(value.format('DD-MM-YYYY') + '-' + moment().format('HH-mm-ss'), 'DD-MM-YYYY-HH-mm-ss')
            : value;
        return novoValor;
    }

    get processos() {
        return (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter(
            (registro) => registro.confirmadaPublicacaoPauta && this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get existeProcessoParaPublicacaoEdital() {
        return this.quantidadeProcessosPublicacaoEdital > 0;
    }

    get quantidadeProcessosPublicacaoEdital() {
        return this.processosPublicacaoEdital.length;
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => registro.confirmadaPublicacaoPauta);
    }

    get mensagemLoteSemProcessos() {
        return 'Não há processos para publicação de edital' + this.complementoMensagemFiltrando;
    }

    render() {
        return (
            this.pautaJulgamentoStore.origemPautaSelecionadaPJe &&
            this.isComponenteHabilitado('PublicarEditalCancelamento') && (
                <>
                    <div
                        className="corBotao"
                        style={{ marginRight: '10px', paddingLeft: '5px' }}
                    >
                        <Tooltip
                            placement="top-start"
                            title={'Publicar edital de cancelamento'}
                        >
                            <UnpublishedOutlined
                                onClick={this.handleClickIcone}
                                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            />
                        </Tooltip>
                    </div>
                    {!!this.dialogListagemOpen && (
                        <Dialog
                            fullWidth
                            open
                            maxWidth="xl"
                            onClose={this.handleCloseDialog}
                            PaperProps={{ style: { height: '100%' } }}
                        >
                            <DialogTitle>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            flexGrow: 1
                                        }}
                                    >
                                        <h4 style={{ margin: '0px' }}>Pulicar edital de cancelamento de processos</h4>
                                        <div style={{ margin: '0px 10px' }}>
                                            <NumeroProcesso
                                                dense
                                                callbackOnChange={this.callbackNumeroProcesso}
                                                clickLimpar={this.limparProcessoPesquisa}
                                                tooltip="Número do processo a ser pesquisado na listagem"
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    margin: '10px',
                                                    paddingTop: '5px'
                                                }}
                                            >
                                                <PainelFiltros />
                                            </div>
                                            <FiltroRapido id="filtroRapidoConfirmarPublicarProcessosLote" />
                                        </div>
                                    </div>
                                </div>
                            </DialogTitle>
                            {this.renderConteudo}
                        </Dialog>
                    )}
                    {this.renderDialogConfirmacao()}
                </>
            )
        );
    }

    get renderConteudo() {
        return this.sessaoStore.carregandoProcessos ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    disableShrink
                    style={{ margin: '20px' }}
                />
                <Typography
                    style={{ margin: '25px 10px' }}
                    variant="h6"
                >
                    Carregando processos...
                </Typography>
            </div>
        ) : (
            <>
                <OperacoesEmLoteSelecionar
                    processos={this.processos}
                    processosSelecionaveis={this.processosSelecionaveis}
                />
                <PainelProcessosOperacoesEmLote
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    processos={this.processos}
                />
                <DialogActions>
                    <Button
                        color="secondary"
                        endIcon={<CancelIcon />}
                        onClick={this.handleCloseDialog}
                        variant="outlined"
                    >
                        Fechar
                    </Button>
                    <Button
                        color="primary"
                        disabled={!this.processosSelecionados || this.processosSelecionados.length === 0}
                        endIcon={<CheckIcon />}
                        onClick={this.handleClickConfirmar}
                        variant="outlined"
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </>
        );
    }

    renderDialogConfirmacao() {
        return (
            this.dialogConfirmacaoOpen && (
                <Dialog
                    fullWidth
                    open
                    maxWidth="md"
                >
                    <DialogTitle>Publicar edital de cancelamento de processos</DialogTitle>
                    <DialogContent>
                        {this.carregando ? (
                            <CircularProgress
                                disableShrink={true}
                                style={{ margin: '10px' }}
                            />
                        ) : (
                            this.renderConteudoConfirmacao()
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.handleCloseDialogConfirmacao}
                            variant="outlined"
                        >
                            Fechar
                        </Button>
                        <Tooltip
                            placement="top-start"
                            title={this.getTooltipBotaoConfirmar()}
                        >
                            <div>
                                <Button
                                    color="primary"
                                    disabled={this.desabilitarConfirmar}
                                    endIcon={<CheckIcon />}
                                    onClick={this.handleConfirmarPublicarEdital}
                                    variant="outlined"
                                >
                                    Confirmar
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    getTooltipBotaoConfirmar() {
        if (this.existeProcessoParaPublicacaoEdital && this.mensagemValidacaoDataDisponibilizacao) {
            return this.mensagemValidacaoDataDisponibilizacao;
        }
        return this.existeProcessoParaPublicacaoEdital ? 'Preencha todos os campos' : '';
    }

    get desabilitarConfirmar() {
        return !this.dataDisponibilizacao || !this.existeProcessoParaPublicacaoEdital;
    }

    get mensagemConfirmacaoPublicacaoDiario() {
        return 'A Secretaria Eletrônica enviará edital de cancelamento para o DJEN.';
    }

    isStringPreenchida(string) {
        return string && (string + '').trim() !== '';
    }

    renderConteudoConfirmacao() {
        return (
            <>
                {this.renderAlertaGeral()}
                {!!this.existeProcessoParaPublicacaoEdital && (
                    <>
                        {this.renderDataDisponibilizacaoDataPublicacao()}
                        {this.renderCamposPublicacao()}
                    </>
                )}
            </>
        );
    }

    getMinDate() {
        return this.dataProximaDisponibilizacao;
    }

    renderDataDisponibilizacaoDataPublicacao() {
        return (
            <>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Data disponibilização</b>
                    </Typography>
                    <DatePicker
                        slotProps={{
                            textField: {
                                helperText: this.mensagemValidacaoDataDisponibilizacao
                            }
                        }}
                        disablePast={true}
                        minDate={this.getMinDate()}
                        onChange={this.handleChangeDataDisponibilizacao}
                        value={this.dataDisponibilizacao}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '50px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Data publicação</b>
                    </Typography>
                    <DatePicker
                        minDate={
                            this.dataDisponibilizacao ? this.dataDisponibilizacao.clone().add(1, 'days') : undefined
                        }
                        disablePast={true}
                        onChange={this.handleChangeDataPublicacao}
                        value={this.dataPublicacao}
                    />
                </div>
            </>
        );
    }

    get mensagemValidacaoDataDisponibilizacao() {
        if (!this.dataDisponibilizacao) {
            return 'Data não informada ou inválida';
        }

        if (!this.dataDisponibilizacao.isValid()) {
            return 'A data informada é inválida';
        }

        if (this.dataDisponibilizacao.isBefore(this.dataProximaDisponibilizacao)) {
            return 'A data informada é anterior à data limite.';
        }

        return null;
    }

    renderCabecalhoPublicacao() {
        return (
            <div style={{ marginBottom: '15px', marginTop: '15px', marginLeft: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0px', paddingLeft: '10px' }}>
                    <Typography
                        color="primary"
                        style={{ paddingRight: '15px', whiteSpace: 'nowrap', textAlign: 'center' }}
                        variant="subtitle1"
                    >
                        <b>Texto Publicação</b>
                    </Typography>
                    <TextField
                        fullWidth={true}
                        id={'cabecalhoPublicacao'}
                        maxRows={15}
                        multiline={true}
                        onChange={this.handleCabecalhoPublicacao}
                        size={'small'}
                        value={this.cabecalhoPublicacao}
                        variant="outlined"
                    />
                </div>
            </div>
        );
    }

    renderCamposPublicacao() {
        return (
            <>
                <div style={{ marginLeft: '81px' }}>
                    <Signatario
                        callbackAlterarCpfSignatario={this.callbackAlterarCpfSignatario.bind(this)}
                        cpfSignatario={this.cpfSignatario}
                    />
                </div>
                {!this.desabilitarPublicar && (
                    <>
                        {this.renderCabecalhoPublicacao()}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '3px 0px',
                                marginLeft: '70px'
                            }}
                        >
                            <Typography
                                style={{
                                    marginRight: '15px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'right',
                                    width: '110px'
                                }}
                                color="primary"
                                variant="subtitle1"
                            >
                                <b>{'Publicador'}</b>
                            </Typography>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <TextField
                                        disabled
                                        fullWidth={true}
                                        id={'teste'}
                                        margin={'dense'}
                                        size={'small'}
                                        value={this.usuarioStore.usuario.nome}
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    renderAlertaGeral() {
        return (
            <div style={{ color: 'orange', marginBottom: '15px', paddingLeft: '10px' }}>
                <Typography
                    fontWeight="bold"
                    style={{ marginBottom: '4px' }}
                >
                    Atenção: Serão publicados editais cancelando o julgamento dos processos.
                </Typography>
            </div>
        );
    }
}

export default inject('stores')(observer(PublicarEditalCancelamentoPautaLote));
